import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { signOut } from '../actions/AuthAction';
import { l10n } from '../i18n/Localization';

class SignOutPage extends Component {
    handleSignOut = () => {
        this.props.signOut();
    };

    render() {
        const { authCompleted, user, authError } = this.props.authState;

        let authHint;
        if (authCompleted) {
            authHint = authError ? authError.message : '';
        } else {
            authHint = l10n.auth.authenticating;
        }

        let authDiv;
        if (user) {
            authDiv = (
                <div>
                    <div className="mb-3">{l10n.auth.signedInHint}</div>
                    <div className="d-flex justify-content-end align-items-center">
                        <span className="mr-3" id="auth-hint">{authHint}</span>
                        <button className="btn btn-warning" type="button" id="sign-out" onClick={this.handleSignOut} disabled={!authCompleted}>{l10n.auth.signOut}</button>
                    </div>
                </div>
            );
        } else {
            authDiv = (
                <div>
                    <div className="mb-3">{l10n.auth.signedOutHint}</div>
                    <div id="auth-hint">{authHint}</div>
                </div>
            );
        }

        const content = (
            <div className="container mt-3">
                {authDiv}
            </div>
        );

        return (
            <div className="SignOutPage">
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content="" />
                    <title>{l10n.auth.signOut} - {l10n.productName}</title>
                </Helmet>
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authState: { ...state.authState },
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => {
            dispatch(signOut());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignOutPage);
